<template>
    <div>
       

      <section class="partners py-5" id="partners">
        <div class="container py-xl-5 py-lg-3">
          <h3 class="tittle text-center font-weight-bold">
            {{ $t("jem.bottomText") }}
          </h3>
          <p class="sub-tittle text-center mt-3 mb-sm-5 mb-4">
            Springer Nature | EIsevier | Taylor&amp;Francis | WILEY | SAGE |
            World Scientific | IEEE | ASME | Cambridge
          </p>
          <h6>◈ {{ $t("jem.bottomText1") }}</h6>
          <div class="row grid-part text-center pt-4">
            <div class="col-md-2 col-4">
              <div class="parts-w3ls">
                <a href="https://www.springernature.com/"
                  ><img src="@/assets/images/SN.png"
                /></a>
                <h4>Springer Nature</h4>
              </div>
            </div>
            <div class="col-md-2 col-4">
              <div class="parts-w3ls">
                <a href="https://www.elsevier.com/"
                  ><img src="@/assets/images/EIsevier.png"
                /></a>
                <h4>EIsevier</h4>
              </div>
            </div>
            <div class="col-md-2 col-4">
              <div class="parts-w3ls">
                <a href="https://taylorandfrancis.com/"
                  ><img src="@/assets/images/TF.png"
                /></a>
                <h4>Taylor&amp;Francis</h4>
              </div>
            </div>
            <div class="col-md-2 col-4 mt-md-0 mt-4">
              <div class="parts-w3ls">
                <a href="https://www.wiley.com/"
                  ><img src="@/assets/images/WILEY.png"
                /></a>
                <h4>WILEY</h4>
              </div>
            </div>
            <div class="col-md-2 col-4 mt-md-0 mt-4">
              <div class="parts-w3ls">
                <a href="https://journals.sagepub.com/"
                  ><img src="@/assets/images/SAGE.png"
                /></a>
                <h4>SAGE</h4>
              </div>
            </div>
            <div class="col-md-2 col-4 mt-md-0 mt-4">
              <div class="parts-w3ls">
                <a href="https://www.emeraldgrouppublishing.com/"
                  ><img src="@/assets/images/Emerald.png"
                /></a>
                <h4>Emerald</h4>
              </div>
            </div>
          </div>
          <div class="row grid-part text-center pt-4">
            <div class="col-md-2 col-4">
              <div class="parts-w3ls">
                <a href="https://www.deguite.eu/"
                  ><img src="@/assets/images/Deguite.png"
                /></a>
                <h4>Deguite</h4>
              </div>
            </div>
            <div class="col-md-2 col-4">
              <div class="parts-w3ls">
                <a href="https://www.worldscientific.com/"
                  ><img src="@/assets/images/WS.png"
                /></a>
                <h4>World Scientific</h4>
              </div>
            </div>
            <div class="col-md-2 col-4">
              <div class="parts-w3ls">
                <a href="https://www.inderscience.com/"
                  ><img src="@/assets/images/IS.png"
                /></a>
                <h4>Inderscience</h4>
              </div>
            </div>
            <div class="col-md-2 col-4">
              <div class="parts-w3ls">
                <a href="https://ioppublishing.org/"
                  ><img src="@/assets/images/IOP.png"
                /></a>
                <h4>IOP</h4>
              </div>
            </div>
          </div>
          <div style="padding-top: 40px">
            <h6>◈ {{ $t("jem.bottomText2") }}</h6>
          </div>
          <div class="row grid-part text-center pt-4">
            <div class="col-md-2 col-4">
              <div class="parts-w3ls">
                <a href="https://www.ieee.org/"
                  ><img src="@/assets/images/IEEE.png"
                /></a>
                <h4>IEEE</h4>
              </div>
            </div>
            <div class="col-md-2 col-4">
              <div class="parts-w3ls">
                <a href="https://www.asme.org/"
                  ><img src="@/assets/images/ASME.png"
                /></a>
                <h4>ASME</h4>
              </div>
            </div>
            <div class="col-md-2 col-4">
              <div class="parts-w3ls">
                <a href="https://pubs.rsc.org/"
                  ><img src="@/assets/images/RSC.png"
                /></a>
                <h4>RSC</h4>
              </div>
            </div>
            <div class="col-md-2 col-4">
              <div class="parts-w3ls">
                <a href="https://www.cam.ac.uk/"
                  ><img src="@/assets/images/Cambridge.png"
                /></a>
                <h4>Cambridge</h4>
              </div>
            </div>
            <div class="col-md-2 col-4">
              <div class="parts-w3ls">
                <a href="https://www.cambridge.org/"
                  ><img src="@/assets/images/CP.png"
                /></a>
                <h4>Cambridge U. Press</h4>
              </div>
            </div>
            <div class="col-md-2 col-4">
              <div class="parts-w3ls">
                <a href="https://www.jstor.org/"
                  ><img src="@/assets/images/JSTOR.png"
                /></a>
                <h4>JSTOR</h4>
              </div>
            </div>
            <div class="col-md-2 col-4">
              <div class="parts-w3ls">
                <a href="https://www.allenpress.com/"
                  ><img src="@/assets/images/AP.png"
                /></a>
                <h4>Allen Press</h4>
              </div>
            </div>
            <div class="col-md-2 col-4">
              <div class="parts-w3ls">
                <a href="https://www.degruyter.com/"
                  ><img src="@/assets/images/DG.png"
                /></a>
                <h4>De Gruyter</h4>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>